module.exports = __webpack_public_path__ + "media/image-testimonial01.da48f14b.png";